import { render, staticRenderFns } from "./BannerAdd.vue?vue&type=template&id=3e57042f&scoped=true"
import script from "./BannerAdd.vue?vue&type=script&lang=js"
export * from "./BannerAdd.vue?vue&type=script&lang=js"
import style0 from "./BannerAdd.vue?vue&type=style&index=0&id=3e57042f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e57042f",
  null
  
)

export default component.exports